import React, { useContext, useEffect, useState } from 'react';
import { Grid, Icon, Button } from 'semantic-ui-react';
//
import DataTool from './toolbar/DataTool';
import AdjustTool from './toolbar/AdjustTool';
import FilterTool from './toolbar/FilterTool';
import ImageTool from './toolbar/ImageTool';
import InfoTool from './toolbar/InfoTool';
//
import styles from './LeftToolbarStyle';
//
import { StoreContext } from '../../../store/StoreProvider';
import Act from '../../../store/actions';

//
const LeftToolbar = ({ loading }) => {
	//
	const [state, dispatch] = useContext(StoreContext);
	const { sna } = state;
	const { dbData, curPubData, regionList, countryList } = sna;
	//
	const [open, setOpen] = useState(false);
	const [activeBtn, setActiveBtn] = useState('data');
	const [filterToolOptMap, setFilterToolOptMap] = useState({});
	//

	useEffect(() => {
		const newFilterToolOptMap = {
			region: {
				title: 'Region',
				public: false,
				data: regionList.map((rg) => ({
					id: rg,
					label: rg,
					checked: true,
					public: true,
				})),
			},
			country: {
				title: 'Country',
				public: true,
				data: countryList.map((ct) => ({
					id: ct,
					label: ct,
					checked: true,
					public: true,
				})),
			},
		};
		setFilterToolOptMap(newFilterToolOptMap);
	}, [regionList, countryList]);

	// 過濾資料
	const onFilterToolOptsMapChange = (optsMap) => {
		const regionCheck = optsMap.region.data.filter((dt) => dt.checked).map((dt) => dt.id);
		const countryCheck = optsMap.country.data.filter((dt) => dt.checked).map((dt) => dt.id);
		const regionKey = ['srcLocRegion', 'dstLocRegion'];
		const countryKey = ['srcLocCountry', 'dstLocCountry'];

		setFilterToolOptMap(optsMap);

		// filter data
		const newFilterData = [...(dbData.initial || [])].filter((dt) => {
			let choose = true;
			regionKey.forEach((rk) => {
				if (rk in dt && !regionCheck.includes(dt[rk])) {
					choose = false;
				}
			});
			countryKey.forEach((ck) => {
				if (ck in dt && !countryCheck.includes(dt[ck])) {
					choose = false;
				}
			});
			return choose;
		});
		dispatch({
			type: Act.SNA_DB_DATA,
			payload: {
				...dbData,
				filter: newFilterData,
			},
		});
	};

	const handleShowComponent = () => true;

	const handleBtnChange = (btnType) => () => {
		setActiveBtn(btnType);
		if (activeBtn === btnType) {
			setOpen(true);
		} else {
			setOpen(true);
		}
	};

	const btnList = {
		toggleDisplay: {
			name: 'toggleDisplay',
			icon: open ? 'angle double left' : 'angle double right',
			show: true,
			click: () => setOpen(!open),
		},
		data: {
			name: 'data',
			icon: 'file',
			color: 'blue',
			show: true,
			click: handleBtnChange('data'),
			component: <DataTool selection={curPubData || {}} usePlaceholder={loading} />,
			handleShowComponent,
		},
		filter: {
			name: 'filter',
			icon: 'filter',
			color: 'teal',
			show: true,
			click: handleBtnChange('filter'),
			component: <FilterTool optionsMap={filterToolOptMap} onOptionsMapChange={onFilterToolOptsMapChange} />,
			handleShowComponent,
		},
		adjust: {
			name: 'adjust',
			icon: 'adjust',
			color: 'yellow',
			show: false,
			click: handleBtnChange('adjust'),
			component: <AdjustTool />,
			handleShowComponent,
		},
		image: {
			name: 'image',
			icon: 'image outline',
			color: 'pink',
			show: false,
			click: handleBtnChange('image'),
			component: <ImageTool />,
			handleShowComponent,
		},
		info: {
			name: 'info',
			icon: 'info',
			color: 'grey',
			show: true,
			click: handleBtnChange('info'),
			component: <InfoTool />,
			handleShowComponent,
		},
	};

	useEffect(() => {
		setOpen(true);
		setActiveBtn('data');
	}, [curPubData]);

	// return !!pubData
	return (
		<Grid style={styles.container}>
			<Grid.Row>
				<Grid.Column width={3} style={{ ...styles.leftCol }}>
					{Object.entries(btnList).map(
						([key, val], idx) =>
							val.show && (
								<Button
									style={styles.toolBarBtn}
									key={idx.toString()}
									color={val.color}
									active={activeBtn === key}
									icon
									onClick={val.click}
								>
									<Icon name={val.icon} />
								</Button>
							)
					)}
				</Grid.Column>
				<Grid.Column width={13} style={{ ...styles.rightCol, ...(!open ? styles.hidden : {}) }}>
					{/* <div style={{ display: 'flex', flexDirection: 'column', ...styles.rightColInnerContainer }}> */}
					{btnList?.[activeBtn] &&
						btnList?.[activeBtn].handleShowComponent() &&
						btnList?.[activeBtn].component}
					{/* </div> */}
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

export default LeftToolbar;
